__turbopack_context__.v({
  "buttonsWrapper": "CookieBanner-module-scss-module__99CmVW__buttonsWrapper",
  "container": "CookieBanner-module-scss-module__99CmVW__container",
  "content": "CookieBanner-module-scss-module__99CmVW__content",
  "description": "CookieBanner-module-scss-module__99CmVW__description",
  "title": "CookieBanner-module-scss-module__99CmVW__title",
});
